import { render, staticRenderFns } from "./TileButton.vue?vue&type=template&id=b87edf0c&scoped=true&"
import script from "./TileButton.vue?vue&type=script&lang=js&"
export * from "./TileButton.vue?vue&type=script&lang=js&"
import style0 from "./TileButton.vue?vue&type=style&index=0&id=b87edf0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87edf0c",
  null
  
)

export default component.exports